import { CheckIcon } from "@heroicons/react/24/outline";

type SaveCompleteProps = {
  message?: string;
};

export default function SaveComplete(props: SaveCompleteProps) {
  return (
    <div className="flex justify-center items-center w-full flex-grow backdrop-blur bg-white bg-opacity-25 z-[100]">
      <div className="flex flex-col items-center">
        <div className="w-20 h-20 flex justify-center items-center rounded-full bg-primary-blue">
          <CheckIcon className="w-12 h-12 text-white" />
        </div>
        <div className="p-2 mt-4 font-semibold text-primary-blue tracking-[0.07rem]">
          {props.message ?? "SAVE COMPLETE"}
        </div>
      </div>
    </div>
  );
}
